import { Lock } from 'lucide-react';
import type { PropertyCommunicationMessageResponse } from '@/shared/api';
import { cn } from '@/shared/lib/cn';
import { MESSAGE_PRESENTATION } from './messagePresentation';

/**
 * Kopf des gewählten Anlasses. Ob er versendet wird, steuert der Schalter in der Gastreise; hier
 * steht nur, was gilt. Ob ein Text angepasst ist, steht an jedem Feld.
 */
export function CommunicationMessageHeader({
  message,
}: {
  message: PropertyCommunicationMessageResponse;
}) {
  const presentation = MESSAGE_PRESENTATION[message.key];
  return (
    <div className="flex min-w-0 flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <p className="text-ink-soft text-[11px] font-semibold uppercase tracking-[0.08em]">
          {presentation.when}
        </p>
        <h3 className="text-ink mt-1 font-serif text-xl">{presentation.title}</h3>
        <p className="text-ink-soft mt-1 max-w-2xl text-sm">{presentation.description}</p>
      </div>
      {message.isRequired ? (
        <span className="bg-ink/5 text-ink inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold">
          <Lock size={11} aria-hidden />
          Pflicht
        </span>
      ) : (
        <span
          className={cn(
            'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold',
            message.isEnabled ? 'bg-sage/10 text-sage' : 'bg-card-alt text-ink-soft',
          )}
        >
          <span
            aria-hidden
            className={cn('size-1.5 rounded-full', message.isEnabled ? 'bg-sage' : 'bg-ink-faint')}
          />
          {message.isEnabled ? 'Aktiv' : 'Inaktiv · wird nicht versendet'}
        </span>
      )}
    </div>
  );
}
